export const MENU_SIZE = 240;
export const FILTER_SIZE = 200;
export const MODAL_SIZE = 720;
export const PAGE_SIZE = 10;
